import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
/**
 * Wrap untrusted HTML in a minimal document so the iframe renders it in
 * roughly the same baseline as a mail client (Arial, 14px, margin 0).
 * `<base target="_blank">` ensures links don't navigate the parent frame.
 */
function minimalWrap(html) {
    return `<!doctype html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"><base target="_blank"></head><body style="margin:0; font-family: Arial, Helvetica, sans-serif; font-size: 14px; color:#111;">${html}</body></html>`;
}
export function HtmlPreview({ html, className, height = '400px', ...rest }) {
    const testId = rest['data-testid'];
    const srcDoc = React.useMemo(() => minimalWrap(html ?? ''), [html]);
    const isFull = height === '100%';
    return (_jsx("div", { "data-testid": testId, className: cn('w-full overflow-hidden rounded-[var(--radius-2)] border border-[var(--color-border-default)] bg-white', isFull && 'h-full', className), children: _jsx("iframe", { title: "HTML preview", sandbox: "allow-same-origin", srcDoc: srcDoc, className: cn('block w-full', isFull && 'h-full'), style: isFull ? { border: 0 } : { height, border: 0 } }) }));
}
//# sourceMappingURL=html-preview.js.map